import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Tab, Nav, NavItem, NavDropdown, MenuItem } from 'react-bootstrap';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { customerJourneyCategories, customerJourneyServices } from './../../../actions';

import './categoryexplorer.scss';

class CategoryExplorer extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      currentCategoryId: null
    }
    this.handleOnSelectCategory = this.handleOnSelectCategory.bind(this);
  }

  /* Handlers */
  handleOnSelectCategory(activeKey) {
    this.props.actions.customerJourneyServices(activeKey, this.props.token, this.props.currentLanguage, this.props.context);
    this.setState({currentCategoryId: activeKey});
  }

  /* Lifecycle */

  componentWillReceiveProps(nextProps) {
    this.setState({currentCategoryId: nextProps.catId});
  }

  render() {
    let navItems = [];
    let menuItems = [];

    if(this.props.categories.apiData.length > 0) {
      this.props.categories.apiData.forEach((category, index) => {
        const categoryLabel = <span><img width={16} height={16} src={category.placeholder} alt={category.name}/> {category.name.toUpperCase()}</span>;
        navItems.push(<NavItem className="hidden-xs hidden-sm" key={category.id} eventKey={category.id}>{categoryLabel}</NavItem>);
        menuItems.push(<MenuItem key={category.id} eventKey={category.id}>{categoryLabel}</MenuItem>);
      });
    }
    else {
      navItems.push(<NavItem key={0} className="hidden-xs hidden-sm" eventKey="loading" disabled><i className="fa fa-ellipsis-h fa-fw"></i></NavItem>);
      menuItems.push(<MenuItem key={0} className="hidden-xs hidden-sm" eventKey="loading"><i className="fa fa-ellipsis-h fa-fw"></i></MenuItem>)
    }

    return (
      <Tab.Container id="events-category-tabs" activeKey={this.state.currentCategoryId} onSelect={this.handleOnSelectCategory} className="customize-categoryexplorer-component">
        <Row className="clearfix">
          <Col xs={12}>
            <Nav bsStyle="tabs">
              {navItems}
              <NavDropdown className="hidden-md hidden-lg" eventKey="collapsed" title={this.props.translate('events.category_explorer.categories')}>
                {menuItems}
              </NavDropdown>
            </Nav>
          </Col>
        </Row>
      </Tab.Container>
    );
  }
}

CategoryExplorer.displayName = 'PagesCustomizeCategoryExplorer';
CategoryExplorer.propTypes = {};
CategoryExplorer.defaultProps = {};

const mapStateToProps = (state) => {
  return { 
      translate: getTranslate(state.locale),
      currentLanguage: getActiveLanguage(state.locale).code,
      token: state.commons.token,
      context: state.commons.context,
      categories: state.categories
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      customerJourneyServices: bindActionCreators(customerJourneyServices, dispatch)
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CategoryExplorer);



// WEBPACK FOOTER //
// ./components/pages/customize/CategoryExplorer.js